import React from 'react';
import PropTypes from 'prop-types';
import { getRootSMSUrl } from '../../helpers/helpers';
import CircleThumbnail from './CircleThumbnail';

function CircleInfo({ circle, description = circle.description, showVisibility = true }) {
  const src = circle.coverImage || circle.previewImage;
  return (
    <>
      <CircleThumbnail src={src} />
      <div className='circle-info'>
        {circle.isSearchable ? (
          <a className='circle-title-link' href={`${getRootSMSUrl()}/shop/circles/${circle.id}`} target='_blank' rel='noopener noreferrer'>
            <strong>{circle.title}</strong> ↗
          </a>
        ) : (
          <strong>{circle.title}</strong>
        )}
        {description && (
          <p className='circle-description' title={description}>
            {description}
          </p>
        )}
        <small>
          ID {circle.id} · {circle.numCurators} creators{showVisibility && ` · ${circle.isSearchable ? 'Public' : 'Hidden'}`}
          {circle.updatedAt ? ` · Updated ${new Date(circle.updatedAt).toLocaleDateString()}` : ''}
        </small>
      </div>
    </>
  );
}

CircleInfo.propTypes = {
  circle: PropTypes.object.isRequired,
  description: PropTypes.string,
  showVisibility: PropTypes.bool
};

export default CircleInfo;
